import Header from "./components/Header";
import Footer from "./components/Footer";
import DisplaySkills from './components/Skills'
import "./assest_css/app.css";

function App() {


  return (
    <main>
      <section id="intro" className="intro">
        <h1>Hello world!</h1>
        <h1 className="green-text">I am Debbie Urquhart.</h1>
        <h1> A Full Stack Software Developer.</h1>
        <div className="project-link">
          <button
            className="btn"
            type="button"
            onClick={() => (window.location.href = "#about")}
          >
            <span className="circle">
              <span className="icon arrow"></span>
            </span>
            <span id="project-btn" className="button-text">
              Oh, tell me more!
            </span>
          </button>
        </div>
      </section>
      <Header className="header" />
      <section className="container" id="about">
        <h2 className="heading">About</h2>
        <p className="container-panel-icon about-text">
          I am a Full Stack Software Developer.
        </p>
      </section>
      <section className="container" id="skills">
        <h2 className="heading">Skills</h2>
        <div className="container-panel-icon"><DisplaySkills/></div>
      </section>
      <Footer />
    </main>
  );
}

export default App;
